import type { IntlKey } from 'locales';
import { FC } from 'react';
import type { ProductGraph } from 'state/product-description/model';

import { BatchFieldNameCell } from './FieldNameCell';

export interface BatchFieldNameColumnProps {
  productDescription: ProductGraph;
}

export const BatchFieldNameColumn: FC<BatchFieldNameColumnProps> = ({ productDescription }) => {
  return (
    <>
      {productDescription.map(blockNode =>
        blockNode.children?.map((fieldNode, fieldIndex, fieldNodeList) => (
          <BatchFieldNameCell
            id={fieldNode.id}
            key={fieldNode.id}
            className={
              fieldIndex === fieldNodeList.length - 1
                ? 'batch-grid-cell is-sticky-left with-border-bottom-thick'
                : 'batch-grid-cell is-sticky-left'
            }
            fieldNameTranslationKey={`form.${fieldNode.translationKey}` as IntlKey}
            tooltipTranslationKey={
              fieldNode.tooltipTranslationKey
                ? (`form.${fieldNode.tooltipTranslationKey}.tooltip` as IntlKey)
                : undefined
            }
          />
        )),
      )}
    </>
  );
};
